var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#178477"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2856 24.6725L22.9971 27.3839L28.9523 21.4287",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2381 35.6913L24 36.397L22.7619 35.6913C20.1259 34.1694 17.9371 31.9801 16.4157 29.3438C14.8943 26.7075 14.094 23.717 14.0952 20.6732C14.0957 20.2389 14.2103 19.8125 14.4276 19.4365C14.6449 19.0606 14.9573 18.7484 15.3333 18.5313L22.8609 14.1856C23.2068 13.9844 23.5998 13.8784 24 13.8784C24.4001 13.8784 24.7931 13.9844 25.139 14.1856L32.6666 18.5313C33.0427 18.7484 33.3551 19.0606 33.5724 19.4365C33.7897 19.8125 33.9043 20.2389 33.9047 20.6732C33.906 23.717 33.1056 26.7075 31.5843 29.3438C30.0629 31.9801 27.8741 34.1694 25.2381 35.6913Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollsIcon);
export default __webpack_public_path__ + "static/media/Rolls-icon.09ce22aaaceebf254d1642be85b2d772.svg";
export { ForwardRef as ReactComponent };